import { FormValues } from './types';

/** Offline machines always install the bundled release, and an empty version means the bundled one too. */
export function versionToInstall(
  { kubesoloVersion, offline }: Pick<FormValues, 'kubesoloVersion' | 'offline'>,
  bundledVersion: string | undefined
) {
  const installsBundled = offline || kubesoloVersion === '';
  return installsBundled ? bundledVersion : kubesoloVersion;
}
